/* eslint import/prefer-default-export: off */

import { createSelector } from 'reselect';
import { property, isEqual } from 'underscore';

const getActiveComponent = property(['rightSidebar', 'component']);
const getComponent = (state, component) => component;

export const makeIsActive = () => createSelector(
  [getActiveComponent, getComponent],
  isEqual,
);
